<template>
    <div class="bg-white dark:bg-gray-800 shadow" :class="{'rounded-lg': !flush}">
        <div
            class="dark:text-white flex justify-between"
            :class="[{'border-b border-gray-200 dark:border-gray-700': ($slots['body'] && isOpen) || $slots['footer'], 'cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700': isCloseable}, !noPadding ? defaultPadding : null]"
            v-if="$slots['header']"
            @click="isCloseable ? isOpen = !isOpen : null"
        >
            <div class="flex align-middle w-full">
                <slot name="header"/>
            </div>

            <div v-if="isCloseable && $slots['body']" class="ml-2 flex justify-center items-center"
                 :class="{'px-4': noPadding}"
            >
                <icon v-if="isOpen" name="chevron-up"></icon>
                <icon v-else name="chevron-down"></icon>
            </div>
        </div>

        <transition
            enter-active-class="transition ease-out duration-100"
            enter-class="transform opacity-0 scale-95"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75"
            leave-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95"
        >
            <div class="dark:text-white" :class="[!noPadding ? defaultPadding : null]" v-if="$slots['body'] && isOpen">
                <slot name="body"/>
            </div>
        </transition>


        <div
            class="bg-gray-50 px-4 py-4 sm:px-6 dark:text-white rounded-b-lg dark:bg-gray-700 border-t border-gray-100 dark:border-gray-600"
            v-if="$slots['footer']"
        >
            <slot name="footer"/>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BaseCard',

    props: {
        isCloseable: {
            type: Boolean,
            default: false,
        },
        isDefaultOpen: {
            type: Boolean,
            default: true,
        },
        flush: {
            type: Boolean,
            default: false,
        },
        noPadding: {
            type: Boolean,
            default: false,
        },
    },

    data: function() {
        return {
            isOpen: true,
            defaultPadding: 'px-4 py-5 sm:p-6',
        };
    },

    mounted() {
        this.isOpen = this.isDefaultOpen;
    },
};
</script>
